<section class="modal-card-body"style="min-width: 800px;">
  @if (Citation != null) {
    <article class="panel">
      <div class="columns">
        <div class="column is-12">
          <a class="panel-block">
            <span class="label">Citation</span>
            <span class="value">{{Citation.Reference || Citation.Id}}</span>
          </a>
          <a class="panel-block">
            <span class="label">Outstanding</span>
            <span class="value">{{Citation.TotalOutstanding | currency:'USD':true:'1.2-2'}}</span>
          </a>
        </div>
      </div>
    </article>
  }
  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label class="label">Manual Payment</label>
    </div>
    <div class="field-body">
      <div class="field">
        <p class="select is-fullwidth">
          <select class="input" [(ngModel)]="SelectedOption">
            @for (p of PaymentOptions; track p) {
              <option [ngValue]="p">{{p.Name}}</option>
            }
          </select>
        </p>
      </div>
    </div>
  </div>
  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label class="label">Payment Type</label>
    </div>
    <div class="field-body">
      <div class="field">
        <label class="radio">
          <input type="radio" name="paymentType" value="full" [(ngModel)]="PaymentType">
          Full Payment
        </label>

        <label class="radio">
          <input type="radio" name="paymentType" value="partial" [(ngModel)]="PaymentType">
          Partial Payment
        </label>
      </div>
    </div>
  </div>
  @if (PaymentType === 'partial') {
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Payment Amount</label>
      </div>
      <div class="field-body">
        <div class="field">
          <input class="input" type="number" placeholder="Enter payment amount" min="0" [max]="Citation.TotalOutstanding" (blur)="onAmountChange($event)">
        </div>
      </div>
    </div>
  }
  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label class="label">Note</label>
    </div>
    <div class="field-body">
      <div class="field">
        <p class="control is-expanded">
          <textarea class="textarea" rows="3" maxlength="2048" [(ngModel)]="NoteContent" placeholder="Required note..."></textarea>
        </p>
      </div>
    </div>
  </div>
</section>
<footer class="modal-card-foot">
  <button class="button has-background-white mr-2" (click)="close()"><span class="icon"><i class="fa fa-xmark"></i></span><span>Cancel</span></button>
  <app-modal-save-button [Disabled]="!(NoteContent || '').trim()" (OnSave)="confirm()"></app-modal-save-button>
</footer>